<script>
export default {
  name: 'TutorialCaller',
  props: {
    name: {
      required: true,
      type: String,
    },
    positioned: {
      type: String,
      default: () => '',
    },
    translations: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    findTutorial: 'findTutorial',
    removeTutorial: 'removeTutorial',
    finishTutorial: 'finishTutorial',
  },
  mounted() {
    this.findTutorial(this.name, this.positioned && {
      el: this.$el,
      position: this.positioned,
    }, this.translations);
  },
  methods: {
    finish() {
      this.finishTutorial(this.name);
    },
  },
  beforeDestroy() {
    this.removeTutorial(this.name);
  },
};
</script>
<template>
  <div
      v-if="positioned"
  >
    <slot :finishTutorial="finish"/>
  </div>
</template>
